import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['hideSideBarClick', 'lockSideBarClick', 'scheduleCallCSClick'] as const;

export const sidebarEvents = getMappedEvents([...EVENTS]);
